module.exports = __webpack_public_path__ + "img/storefront.52a8e498.svg";